<a href="{{externalLink}}" [ngClass]="customClass" target="_blank">{{text}}</a>
